<input
  #importFileInput
  type="file"
  accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
  class="kl-grid-form-import-input"
  (change)="onImportFileInput($event)" />

@if (showToolbarArea()) {
  <div class="kl-grid-form-toolbar">
    @if (!isReadOnly() && showAddRow()) {
      <p-button
        type="button"
        [label]="'add_new_line' | translate"
        icon="ph ph-plus"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="addRowClick.emit()" />
    }
    @if (searchEnabled()) {
      <p-button
        type="button"
        [label]="'search' | translate"
        icon="ph ph-magnifying-glass"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="searchClick.emit()" />
    }
    @if (!isReadOnly() && importEnabled()) {
      <p-button
        type="button"
        [label]="'import_inside' | translate"
        icon="ph ph-upload-simple"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="importMenu.toggle($event)" />
      <p-menu #importMenu [model]="importMenuItems()" [popup]="true" appendTo="body" />
    }
    @if (exportEnabled()) {
      <p-button
        type="button"
        [label]="'export' | translate"
        icon="ph ph-download-simple"
        severity="secondary"
        size="small"
        [text]="true"
        [disabled]="rowsLength() === 0"
        (onClick)="exportClick.emit()" />
    }
    @if (processButtons().length) {
      <p-button
        type="button"
        [label]="'processes' | translate"
        icon="ph ph-caret-down"
        iconPos="right"
        severity="secondary"
        size="small"
        [text]="true"
        class="kl-grid-form-toolbar__processes"
        (onClick)="processMenu.toggle($event)" />
      <p-tieredmenu #processMenu [model]="processMenuItems()" [popup]="true" appendTo="body" />
    }
    @if (fullscreenEnabled()) {
      <p-button
        type="button"
        [label]="fullscreenLabelKey() | translate"
        [icon]="fullscreenIcon()"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="fullscreenClick.emit()" />
    }
    @if (!isReadOnly() && bulkDeleteEnabled()) {
      <p-button
        type="button"
        [label]="'bulk_delete' | translate"
        icon="ph ph-trash"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="bulkDeleteClick.emit()" />
    }
    @if (customToolbarVisible() && customToolbar().length) {
      @for (a of customToolbar(); track a.slug) {
        @if (!a.separator) {
          <p-button
            type="button"
            [label]="a.slug_2 ?? a.slug | translate"
            [icon]="a.icon ?? ''"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="customToolbarActionClick.emit(a)" />
        }
      }
    }
    @if (toolbarTemplate(); as tpl) {
      <ng-container *ngTemplateOutlet="tpl" />
    }
  </div>
}
@if (searchEnabled() && searchPanelOpen()) {
  <div class="kl-grid-form-search-panel">
    <input
      pInputText
      type="search"
      class="kl-grid-form-search-input"
      [ngModel]="searchQuery()"
      (ngModelChange)="searchQueryChange.emit($event)"
      [placeholder]="'search_value' | translate" />
  </div>
}
